import React, { useEffect } from "react"
import { useParams } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"

import PageHeader from "../../components/PageHeader"
import About from "./About"
import Bio from "./Bio"
import NextAlumni from "./NextAlumni"
import "./alumni-single-page.css"
import { apiBaseURI } from "../../config"
import { fetchAlumniOfTheMonthDetails } from "../../features/alumni-of-the-month/alumniOfTheMonthSlice"

const AlumniOfTheMonthSingle = () => {
    let params = useParams()

    let dispatch = useDispatch()

    const { alumniDetails } = useSelector((state) => state.alumniOfTheMonthpage)

    useEffect(() => {
        dispatch(fetchAlumniOfTheMonthDetails(params.slug))
    }, [dispatch, params.slug])

    return (
        <>
            <PageHeader
                image={`${apiBaseURI}${alumniDetails.cover_image_url}`}
                text={false}
            />
            <About
                name={alumniDetails.name}
                image={`${apiBaseURI}${alumniDetails.image_url}`}
                award_month={alumniDetails.award_month}
                degreeYear={alumniDetails.degree_year}
            />
            <Bio about={alumniDetails.description} />
            <NextAlumni
                next={alumniDetails.next}
                prev={alumniDetails.previous}
            />
        </>
    )
}

export default AlumniOfTheMonthSingle
